import { useQuery } from "@tanstack/react-query";

import {
    fetchTrackList,
    searchArtistTracks,
    fetchAlbumPlaylistTracks,
} from "../api/artistTracks.api";
import { showToast } from "../helper/ShowToast";

// Tracklist query
export const useArtistTrackList = (type, enabled = true) =>
  useQuery({
    queryKey: ["artistTracks", type],
    queryFn: () => fetchTrackList({ type }),
    enabled,
    onError: (error) => {
      showToast(
        "error",
        error.response?.data?.message || error.message || "Failed to load artist tracks"
      );
    },
  });

// Search query
export const useSearchArtistTracks = (params, enabled) =>
  useQuery({
    queryKey: ["artistTrackSearch", params],
    queryFn: () => searchArtistTracks(params),
    enabled,
    onError: (error) => {
      showToast(
        "error",
        error.response?.data?.message || error.message || "Search failed"
      );
    },
  });

// Album / Playlist tracks
export const useAlbumPlaylistTracks = ({ id, type }, enabled) =>
  useQuery({
    queryKey: ["albumPlaylistTracks", id, type],
    queryFn: () => fetchAlbumPlaylistTracks({ id, type }),
    enabled,
    onError: (error) => {
      showToast(
        "error",
        error.response?.data?.message || error.message || "Failed to load tracks"
      );
    },
  });